"use client";

import { useState, useEffect, useMemo } from "react";
import { Spinner } from "@nextui-org/react";
import dynamic from "next/dynamic";
import { useRouter } from "next13-progressbar";
import { ODSSelector } from "../(components)/ODSSelector";

import { fetchOds } from "@/app/indicators/ods/actions/ods";

const formatToSeries = (name, items) => [
  {
    name,
    data: items.map((item) => ({
      name: `ODS ${item.index}: ${item.label}`,
      value: item.count,
    })),
  },
];

const PackedBubble = dynamic(() => import("@/app/charts/PackedBubble"), {
  ssr: false,
  loading: () => <Spinner size="large" label="Cargando gráfico" />,
});

// --- Componentes Pequeños para legibilidad ---
const ODSTable = ({ seriesData }) => (
  <div className="flex flex-col">
    <div className="flex flex-row border text-sm uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold py-3">
      <div className="w-4/5 text-wrap">Objetivo de desarrollo sostenible</div>
      <div className="w-1/5 text-wrap"># pubs</div>
    </div>
    <div className="flex flex-col">
      {seriesData.map((ods, idx) => (
        <div className="flex flex-row py-1 text-tiny" key={idx}>
          <div className="w-4/5 text-wrap text-left">{ods.name}</div>
          <div className="w-1/5 text-wrap">{ods.value}</div>
        </div>
      ))}
    </div>
  </div>
);

export default function IndicatorsOdsDocumentsPage() {
  const router = useRouter();

  // Estados
  const [data, setData] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [loading, setLoading] = useState(true);

  // Lógica de navegación
  const handlePointClick = (name) => {
    router.push(`/explore/documents?p=1&f=ods_str:"${name}"`);
  };

  // Carga de datos
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const resp = await fetchOds();
      setData(resp);
      setLoading(false);
    };
    fetchData();
  }, []);

  // Transformación de datos (Mantenibilidad: una sola fuente de verdad)
  const series = useMemo(() => {
    if (!selectedValue) {
      return formatToSeries("Todos los ODS", data);
    }
    return formatToSeries(selectedValue.label, [selectedValue]);
  }, [data, selectedValue]);

  const handleOnChange = (val) => {
    if (val === "") {
      setSelectedValue(null);
    } else {
      const selected = data.find(({ index }) => index == val);
      setSelectedValue(selected || null);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center mt-10">
        <Spinner size="large" label="Cargando datos..." />
      </div>
    );
  }

  return (
    <div className="flex flex-col text-left">
      <ODSSelector
        data={data}
        handleOnChange={handleOnChange}
        selectedValue={selectedValue}
      />

      <div className="flex flex-col md:flex-row gap-5 mt-10">
        {/* Panel Izquierdo: Lista/Tabla */}
        <div
          className="w-full md:w-1/3 overflow-auto mb-5 pr-2"
          style={{ height: "75vh" }}
        >
          <ODSTable seriesData={series[0]?.data || []} />
        </div>

        {/* Panel Derecho: Gráfico */}
        <div className="w-full md:w-2/3">
          <PackedBubble series={series} handlePointClick={handlePointClick} />
        </div>
      </div>
    </div>
  );
}
